import { fetchPatientsList } from '@/api/services/user';
import {
  Patient,
  WordSetFromApi,
  TextSetFromApi,
  SentenceSetFromApi,
} from '@/stores/store.types';

type SetKeyName = 'wordsets' | 'textsets' | 'sentencesets';
type AnySetFromApi = WordSetFromApi | TextSetFromApi | SentenceSetFromApi;

interface FetchUpdatedPatientResult {
  patients: Patient[];
  patient?: Patient;
}

export async function fetchUpdatedPatientWithRetry(
  patientId: string,
  dataKeyName: SetKeyName,
  newSetId?: string,
  maxAttempts: number = 3,
  delay: number = 800,
): Promise<FetchUpdatedPatientResult> {
  let attempts = 0;
  let patients: Patient[] = [];
  let patient: Patient | undefined;
  let found = false;

  while (attempts < maxAttempts) {
    patients = await fetchPatientsList();
    patient = patients.find((p) => p._id === patientId);

    if (patient) {
      const updatedSets: AnySetFromApi[] = patient[dataKeyName] ?? [];
      found = newSetId
        ? updatedSets.some((s) => String(s._id) === String(newSetId))
        : true;

      if (found) {
        break;
      }
    }

    attempts++;
    if (!found && attempts < maxAttempts) {
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }

  return { patients };
}
